import { useAuth } from "@/contexts/auth-context";
import "./styles.scss";
import { Button, Icon } from "@/components";

export function Verdict({
  open,
  is_answer,
  answer,
  onClose,
  handleNext,
}: {
  open: boolean;
  is_answer: boolean;
  answer: string;
  onClose: () => void;
  handleNext: () => void;
}) {
  const { updateTrialCount, trialCount } = useAuth();

  const handleClick = () => {
    const newCount = trialCount + 1;
    updateTrialCount(newCount);
    if (is_answer) {
      onClose();
      handleNext();
    } else onClose();
  };

  const getRandomSuccessMessage = (): string => {
    const messages: string[] = [
      "Great! you are crushing it!",
      "Right on! You got it",
      "Yes! That's correct.",
      "Awesome! Keep that going.",
      "Great! You are crushing it!",
    ];

    const randomIndex: number = Math.floor(Math.random() * messages.length);
    return messages[randomIndex];
  };

  const getRandomFailMessage = (): string => {
    const messages: string[] = [
      "Let's try this again",
      "Not quite! Give it another go.",
      "That's a no. Take another shot!",
      "Nope! Think about it one more time.",
      "Incorrect. Don't worry, you'll get the next one!",
    ];

    const randomIndex: number = Math.floor(Math.random() * messages.length);

    return messages[randomIndex];
  };

  if (!open) return null;
  return (
    <div
      className="verdict_container"
      data-is-answer={String(is_answer)}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="inner_container">
        <div>
          {is_answer ? (
            <div className="is_answer">
              <Icon name="correct" />
              Correct
            </div>
          ) : (
            <div className="is_answer">
              <Icon name="wrong" />
              Wrong
            </div>
          )}

          <div className="answer">
            {is_answer ? getRandomSuccessMessage() : getRandomFailMessage()}
          </div>
        </div>
        <Button variant="secondary" onClick={handleClick}>
          Got it
        </Button>
      </div>
    </div>
  );
}
